export default __webpack_public_path__ + "static/media/maps-icon.f1e89bd7.svg";